import type * as api from '@gitbook/api-client';
import { validateAnyContentReference } from '@gitbook/app-content-refs';
import { Block, Schema } from '@gitbook/slate';

import {
    BLOCK_COLUMN,
    BLOCK_CONTENT_REF,
    BLOCK_IF,
    BLOCK_STEPPER_STEP,
    BLOCK_TABS_ITEM,
    BLOCK_UPDATE,
} from '../types';

/**
 * Schema to validate contentRef.
 */
export const schema = Schema.create({
    blocks: {
        [BLOCK_CONTENT_REF]: {
            parent: {
                objects: ['document', 'block'],
                types: [
                    undefined,
                    BLOCK_TABS_ITEM,
                    BLOCK_COLUMN,
                    BLOCK_STEPPER_STEP,
                    BLOCK_UPDATE,
                    BLOCK_IF,
                ],
            },
            data: {
                ref: validateAnyContentReference,
            },
        },
    },
});

/**
 * Utility to create a content-ref block.
 */
export function createContentRefBlock(ref: api.ContentRef): Block {
    return Block.createVoid({
        type: BLOCK_CONTENT_REF,
        data: {
            ref,
        },
    });
}
